import { render, staticRenderFns } from "./metamask.vue?vue&type=template&id=0a32f5bd&"
import script from "./metamask.vue?vue&type=script&lang=js&"
export * from "./metamask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports